import { useQuery, useQueryClient } from "@tanstack/react-query";
import { RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Card } from "../../components/admin/Section";

const NAMES = { general: "Genel", profile: "Profil", theme: "Tema", campaign: "Kampanya", features: "Özellikler", ai: "Yapay Zeka", communication: "İletişim", seo: "SEO", language: "Dil", security: "Güvenlik" };
const when = (s) => new Date(s).toLocaleString("tr-TR", { dateStyle: "medium", timeStyle: "short" });

export default function HistoryTab() {
  const qc = useQueryClient();
  const { data = [], isLoading } = useQuery({ queryKey: ["admin", "settings-history"], queryFn: () => api.get("/admin/settings-history").then((r) => r.data) });
  const restore = async (h) => {
    if (!window.confirm(`${NAMES[h.section] || h.section} ayarları ${when(h.at)} tarihli hâline döndürülsün mü? Şu anki hâl de geçmişe kaydedilir.`)) return;
    try {
      const r = await api.post(`/admin/settings-history/${h.id}/restore`);
      qc.setQueryData(["admin", "settings"], r.data);
      qc.invalidateQueries({ queryKey: ["site"] });
      qc.invalidateQueries({ queryKey: ["admin", "settings-history"] });
      toast.success("Ayarlar geri yüklendi");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Card title="Ayar geçmişi" sub="Her kayıttan önce o bölümün önceki hâli saklanır (bölüm başına son 30 kayıt). Bir şey kaybolursa buradan geri alabilirsiniz." testid="settings-history">
      {isLoading && <p className="text-sm text-stone-400">Yükleniyor…</p>}
      {!isLoading && !data.length && <p className="text-sm text-stone-400" data-testid="history-empty">Henüz kayıt yok. Bir ayarı kaydettiğinizde önceki hâli burada görünür.</p>}
      <div className="divide-y border rounded-lg" data-testid="history-list">
        {data.map((h) => (
          <div key={h.id} className="flex items-center justify-between gap-4 px-4 py-3" data-testid={`history-row-${h.id}`}>
            <div>
              <p className="text-sm font-medium">{NAMES[h.section] || h.section}</p>
              <p className="text-xs text-stone-500">{when(h.at)} tarihinden önceki hâli</p>
            </div>
            <Button size="sm" variant="outline" onClick={() => restore(h)} data-testid={`history-restore-${h.id}`}><RotateCcw size={14} className="mr-1" />Geri yükle</Button>
          </div>
        ))}
      </div>
    </Card>
  );
}
